export enum InteractiveElementPromptType {
  soloBot = 'solo_bot',
  talkTrack = 'talk_track',
  soloModeratorBot = 'solo_moderator_bot',
  soloGraderBot = 'solo_grader_bot',
  soloTutorBot = 'solo_tutor_bot',
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const InteractiveElementPromptTypeMap = {
  soloBot: InteractiveElementPromptType.soloBot,
  talkTrack: InteractiveElementPromptType.talkTrack,
  soloModeratorBot: InteractiveElementPromptType.soloModeratorBot,
  soloGraderBot: InteractiveElementPromptType.soloGraderBot,
  soloTutorBot: InteractiveElementPromptType.soloTutorBot,
}

export const InteractiveElementPromptTypeReverseMap = {
  [InteractiveElementPromptType.soloBot]: 'solo_bot',
  [InteractiveElementPromptType.talkTrack]: 'talk_track',
  [InteractiveElementPromptType.soloModeratorBot]: 'solo_moderator_bot',
  [InteractiveElementPromptType.soloGraderBot]: 'solo_grader_bot',
  [InteractiveElementPromptType.soloTutorBot]: 'solo_tutor_bot',
}

export const InteractiveElementPromptTypeList = [
  InteractiveElementPromptType.soloBot,
  InteractiveElementPromptType.talkTrack,
  InteractiveElementPromptType.soloModeratorBot,
  InteractiveElementPromptType.soloGraderBot,
  InteractiveElementPromptType.soloTutorBot,
]

export const InteractiveElementPromptTypeNames = Object.keys(
  InteractiveElementPromptTypeMap
)
